import React, { useState } from "react";
import coupleImg from "../../Assets/SignUp/coupleImg.jpeg";
import heading from "../../Assets/SignUp/heading.png";
import bg from "../../Assets/SignUp/bg.png";
import absolute from "../../Assets/SignUp/absolute.png";
import { FcGoogle } from "react-icons/fc";
import { MdOutlineRemoveRedEye } from "react-icons/md";
import { FaRegEyeSlash } from "react-icons/fa";
import { NavLink, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { userlogin } from "../../Redux/Actions/AuthAction";
import { CircularProgress } from "@mui/material";
import { toast } from "react-toastify";
import useTitle from "../../Hooks/useTitle";
import couple1 from "../../Assets/review/db2.jpg"


const Signin = () => {
  useTitle("Sign in");
  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState();
  const [password, setPassword] = useState();

  const navigate = useNavigate();
  const { loading } = useSelector((state) => state.Auth);
  const dispatch = useDispatch();
  const handleGoogleLogin = () => {
    const base_url = process.env.REACT_APP_BASE_API_URL;
    window.location.href = `${base_url}/auth/google`; // Laravel route
  };

  // const handleGoogleLogin = async (e) => {
  //   e.preventDefault();
  //   try {
  //     const provider = new firebase.auth.GoogleAuthProvider();
  //     const result = await firebase.auth().signInWithPopup(provider);
  //     const token = await result.user.getIdToken();

  //     // Send the Firebase token to your backend (Laravel API)
  //     const response = await fetch('http://localhost:8000/api/auth/firebase', {
  //       method: 'POST',
  //       headers: {
  //         'Content-Type': 'application/json',
  //       },
  //       body: JSON.stringify({
  //         token: token,
  //       }),
  //     });

  //     const data = await response.json();
  //     if (data.success) {
  //       setUser(data.user);
  //     } else {
  //       console.error('Login failed');
  //     }
  //   } catch (error) {
  //     console.error('Google login error: ', error);
  //   }
  // };

  const handleSignin = async (e) => {
    e.preventDefault();
    if (!email || !password) {
      return toast.error("all fields are required");
    }
    try {
      const res = await dispatch(userlogin(email, password));

      console.log('res', res);
      localStorage.setItem("admin", res?.data?.data?.user?.is_admin);
 
      navigate("/");
    } catch (error) {
      toast.error(error.response.data.message);
    }
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 h-screen overflow-hidden">
      {/* Left Side Image */}
      <div className="hidden md:flex relative justify-center items-center p-4 h-full overflow-hidden">
        <div className="w-full h-full relative">
          <img
            src={couple1}
            alt="Couple"
            className="w-full h-full object-cover rounded-xl"
          />
          {/* Overlay Content */}
          <div className="absolute top-4 left-1/2 transform -translate-x-1/2 text-center text-white">
            <img
              src={absolute}
              alt="Decorative Icon"
              className="mx-auto mb-2"
            />
            <h1 className="text-3xl  font-bold">USA</h1>
            <h2 className="text-3xl  font-bold">
              Gujarati Community
            </h2>
          </div>
        </div>
      </div>

      {/* Right Side Form */}
      <div
        className="flex items-center justify-center lg:h-full lg:overflow-hidden"
        style={{
          backgroundImage: `url(${bg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="max-w-xl w-full py-24 p-6 lg:h-full lg:flex lg:flex-col lg:justify-center ">
          <div className="flex justify-center">
            <img
              src={heading}
              alt="Matrimony"
              className="h-10 md:h-12 w-28 md:w-32"
            />
          </div>
          <h2 className="text-center text-lg md:text-xl font-semibold my-2">
            Welcome Back!
          </h2>

          <form className="flex flex-col">
            {/* Email Section */}
            <label className="block font-medium mt-2 mb-1">Email ID</label>
            <input
              type="email"
              placeholder="Email id"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full p-3 border border-[#D5D7DA] rounded-xl focus:outline-none focus:ring-2 focus:ring-[#E72848] shadow-[0px_1px_2px_0px_#0A0D120D]"
            />

            {/* Password Section */}
            <label className="block font-medium mt-2 mb-1">Password</label>
            <div className="relative">
              <input
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full p-3 border border-[#D5D7DA] rounded-xl focus:outline-none focus:ring-2 focus:ring-[#E72848] shadow-[0px_1px_2px_0px_#0A0D120D]"
                placeholder="Enter your password"
              />
              <span
                className="absolute right-3 top-1/2 transform -translate-y-1/2 cursor-pointer"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? (
                  <FaRegEyeSlash size={20} />
                ) : (
                  <MdOutlineRemoveRedEye size={22} />
                )}
              </span>
            </div>

            {/* Remember Me & Forgot Password */}
            <div className="flex flex-wrap items-center justify-between mt-2 text-sm">
              <div className="flex items-center">
                <input type="checkbox" className="mr-2 w-4 h-4" />
                <span>Remember me</span>
              </div>
              <NavLink
                to="/forgot-password"
                className="text-blue-500 font-medium cursor-pointer hover:underline"
              >
                Forgot Password?
              </NavLink>
            </div>

            {/* Login Button */}
            <button
              type="submit"
              className={`w-full bg-[#E72848] flex justify-center text-white text-lg p-2 my-4 rounded-xl font-semibold hover:bg-[#f53b58] transition duration-300`}
              onClick={handleSignin}
              disabled={loading}
            >
              {loading ? (
                <CircularProgress size={24} color="inherit" />
              ) : (
                "Log In"
              )}
            </button>

            {/* OR Separator */}
            <div className="flex items-center my-2">
              <hr className="flex-grow border-gray-300" />
              <span className="px-3 text-gray-600">Or</span>
              <hr className="flex-grow border-gray-300" />
            </div>

            {/* Google Login */}
            <button
              type="button"
              onClick={handleGoogleLogin}
              className="w-full flex justify-center items-center border border-gray-300 p-3 rounded-xl hover:bg-gray-100 transition duration-300 cursor-pointer"
            >
              <FcGoogle size={26} className="mr-2" />
              <span
                className="font-semibold text-black"
              >
                Log In with Google
              </span>
            </button>

            <p className="text-center mt-2 text-sm">
              Don’t have an account?
              <NavLink
                to="/signup"
                className="text-[#E72848] font-semibold ml-1 hover:underline"
              >
                Sign Up
              </NavLink>
            </p>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Signin;